export const addClassToBody = () => document.querySelector("body").className = "sign-page";

export const RemoveClassFromBody = () => document.querySelector("body").classList.remove("sign-page");

export const modifyAuthError = error => {
    const message = error.response.data.errors[0].message;
    return {[message === 'Email does not exists.' ? 'email' : 'password']: message};
};



// WEBPACK FOOTER //
// ./src/utils/utils.js